<template>
    <b-tabs content-class="mt-3 print-tabs">
        <b-tab title="Templates" active>
            <paper-choices
                v-if="printSettings && printConfiguration"
                :settings-formats="printSettings.templates"
                :default-components="printSettings.default.components"
                :print-configuration="printConfiguration"
                :key="`paperChoice${componentUpdateIndex}`"
                :isSaving="isSaving"
                @update="$_onUpdateSettingsFormats"
                @save="$_onSaveSettingsFormats"
                @resetSettings="$_onRevertToFactoryDefaultSettings"
            />
        </b-tab>
        <b-tab title="Onderdelen">
            <page-configuration
                v-if="printSettings && printConfiguration"
                key="default-settings"
                :default-components="printSettings.default.components"
                :print-configuration="printConfiguration"
                @save="$_onChangeDefaultSettings"
            />
        </b-tab>
        <b-tab title="Basisinstellingen">
             <print-settings-form-configuration
                v-if="printSettings && printConfiguration"
                key="print-settings-form-configuration"
                :default-form="printSettings.default.form"
                :print-configuration="printConfiguration"
                @save="$_onChangeDefaultFormSettings"
            />
        </b-tab>
        <b-tab title="Editor">
            <div>
                <div class="form-group">
                    <a href="#" @click.stop.prevent="$_onUpdateFactoryDefaultSettings">
                        {{$t('printComponent.dashboard.updateTemplatesFactory')}}
                    </a>
                </div>
            </div>
            <div class="form-group">
                <h4>{{$t('printComponent.dashboard.settingsFactory')}}</h4>
                <textarea v-model="printConfigurationString"></textarea>
                <b-button v-on:click="$_saveConfiguration">{{$t('btnSaveLabel')}}</b-button>
            </div>
            <div class="form-group">
                <h4>{{$t('printComponent.dashboard.settingsOrganization')}}</h4>
                <textarea v-model="printSettingsString"></textarea>
                <b-button v-on:click="$_saveSettings">{{$t('btnSaveLabel')}}</b-button>
            </div>
        </b-tab>
    </b-tabs>
</template>

<script>
    import { mapActions } from 'vuex';
    import PaperChoices from './PaperChoices.vue';
    import PageConfiguration from './PageConfiguration.vue';
    import PrintSettingsFormConfiguration from './PrintSettingsFormConfiguration.vue';
    import modalMixin from '../../../components/Mixins/ModalMixin.vue';

    export default {
        mixins: [
            modalMixin
        ],
        components: {
            'paper-choices': PaperChoices,
            'page-configuration': PageConfiguration,
            'print-settings-form-configuration': PrintSettingsFormConfiguration
        },
        props: {},

        data() {
            return {
                printConfiguration: null,
                printSettings: null,
                printConfigurationString: null,
                printSettingsString: null,
                defaultConfiguration: null,
                componentUpdateIndex: 0,
                isSaving: false
            };
        },

        async created() {
            this.printSettings = await this.getPrintParameters();
            this.printConfiguration = await this.getPrintConfiguration();
            this.defaultConfiguration = this.printConfiguration.default;
        },

        methods: {
            ...mapActions(['getPrintParameters', 'getPrintConfiguration', 'savePrintConfiguration', 'savePrintParameters']),
            $_onRevertToFactoryDefaultSettings() {
                this.msgBoxConfirm( { message: this.$t('printComponent.dashboard.confirmOverwriteTemplates') } ).then((confirm) => {
                    if (confirm) {
                        this.printSettings = this.defaultConfiguration;
                        this.componentUpdateIndex += 1;
                        this.$_saveSettings();
                    }
                });
            },
            $_onUpdateFactoryDefaultSettings() {
                this.msgBoxConfirm({ message: this.$t('printComponent.dashboard.confirmUpdateTemplates') }).then((confirm) => {
                    if (confirm) {
                        this.printConfiguration = { ...this.printConfiguration, default: { ...this.printSettings } };
                        this.$_saveConfiguration();
                    }
                });
            },
            async $_saveConfiguration() {
                try {
                    const config = await this.savePrintConfiguration(this.printConfiguration);
                    if (config) {
                        this.$_showToastSuccess();
                    }
                } catch (error) {
                    this.$_showToastError(error);
                }
            },
            async $_saveSettings() {
                try {
                    const settings = await this.savePrintParameters(this.printSettings);
                    if (settings) {
                        this.$_showToastSuccess();
                    }
                } catch (error) {
                    this.$_showToastError(error);
                }
            },
            $_onChangeDefaultFormSettings(form) {
                this.printSettings = { ...this.printSettings, default: { ...this.printSettings.default, form } };
                this.componentUpdateIndex += 1;
                this.$_saveSettings();
            },
            $_onChangeDefaultSettings(components) {
                this.printSettings = { ...this.printSettings, default: { ...this.printSettings.default, components } };
                this.componentUpdateIndex += 1;
                this.$_saveSettings();
            },
            $_onUpdateSettingsFormats(templates) {
                this.printSettings = { ...this.printSettings, templates };
            },
            $_onSaveSettingsFormats(templates) {
                this.$_onUpdateSettingsFormats(templates);
                this.$_saveSettings();
            },
            $_onSaveConfig(config) {
                this.printConfiguration = config;
                this.componentUpdateIndex += 1;
            },
            $_showToastSuccess() {
                this.showToast({ message: this.$t('feedbackProcessed'), variant: 'success', autoHideDelay: 2500 });
            },
            $_showToastError(error) {
                this.showToast({ message: error.message, variant: 'danger', title: this.$t('saveFailureTitle'), autoHideDelay: 2500 });
            }
        },

        watch: {
            printSettings(newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                if (newValue === '') {
                    this.$_onRevertToFactoryDefaultSettings();
                } else {
                    this.printSettingsString = JSON.stringify(newValue);
                }
            },
            printConfiguration(newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                this.printConfigurationString = JSON.stringify(newValue);
            },
            printSettingsString(newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                this.printSettings = JSON.parse(newValue);
            },
            printConfigurationString(newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                this.printConfiguration = JSON.parse(newValue);
            }
        }
    };
</script>

<style scoped>
    textarea {
        width: 100%;
        height: 500px;
    }
</style>

<style>
    .print-tabs {
        height: calc(100vh - 260px); /* 260 = toolbar + title + footer */
        overflow-y: auto;
    }
</style>
